<template>
  <v-chip
    small
    label
    class="text-uppercase font-weight-bold"
    :class="`status_${status}`"
  >
    {{
      status === 0
        ? $t('alert_case_details.table.headers.status.options.pending')
        : (status === 1
          ? $t('alert_case_details.table.headers.status.options.true')
          : $t('alert_case_details.table.headers.status.options.false'))
    }}
  </v-chip>
</template>

<script>
export default {
  props: {
    status: {
      type: Number,
      required: true
    }
  }
}
</script>

<style>
.status_0 {
  background-color: #f8dfc3 !important;
  color: #e29350 !important;
}

.status_1 {
  background-color: #f6cfcb !important;
  color: #dd6d6b !important;
}

.status_2 {
  background-color: #cdfde1 !important;
  color: #55b189 !important;
}
</style>
